import Spinner from 'react-bootstrap/Spinner';
import {Modal, Row, Col,Button, Card, Form} from 'react-bootstrap'
import DataTable from  '../DataTable/DataTable';
import { useEffect, useState,useRef } from 'react';
import { Navigate } from "react-router-dom";
import Layout from '../../layout/default';
import { Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../../components";
import { Dropdown } from "react-bootstrap";
import { Block, BlockHead, BlockHeadBetween, BlockHeadContent} from '../../components';
import { Alert } from 'react-bootstrap';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = "HMCareSettings/skillList/";

const pagetitle = "Qualifications and Training";
const pagetitleAddNew = "Add Qualification";
const pagetitleUpdate = "Update Qualification";


export const tableColumns = [
    {
      name: "id",
      selector: (row) => row.id,
      sortable: false,
      hide : "lg",
      omit : true,

    },
    {
        name: "name",
        selector: (row) => row.qualificationName,
        sortable: true,                        
    },
    {
        name: "Duration",
        selector: (row) => row.duration,
        sortable: true,                        
    },
    {
        name: "Cost",
        selector: (row) => '£'+row.cost?.toFixed(2),
        sortable: true,                        
    },
    {
        name: "Date Modified",
        selector: (row) => new Date(row.dateModified).toLocaleString(),
        sortable: true,                
    },
    {
        name: "Date Created",
        selector: (row) => new Date(row.dateCreated).toLocaleString(),
        sortable: true,                
    },
    {
        name: "",
        Button:true,              
        cell: (row) => (                 
            <>
            <Icon name="edit-fill"></Icon>Edit
            </>           
        ),
        sortable: false,      
    },
]


// ...imports remain unchanged...

const SkillsSettings = () => {
    const api = useApiClient();
    const dataFetchedRef = useRef(false);

    const [DatatoUse, setData] = useState(null);
    const [error, setError] = useState(null);
    const [selectedData, setSelectedData] = useState([]);
    const [previewModal, setPreviewModal] = useState(false);
    const [AddModal, setAddModal] = useState(false);

    // Validation error state
    const [formErrors, setFormErrors] = useState({});

    const modalForm = useRef(null);

    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;
        api.get(baseURL)
            .then((Response) => {
                setData(Response.data);
            }).catch(error => {
                setError(error);
            });
    }, []);

    if (error) {
        if (error.message.indexOf("status code 401")) {
            return <Navigate to="/auths/auth-login" />
        } else {
            return "Error: " + error.message;
        }
    }

    if (!DatatoUse) return (
        <Layout title="Data" content="container"><Spinner animation="border" variant="primary" /></Layout>
    );

    function detailSelect(obj) {
        setFormErrors({});
        setSelectedData({
            id: obj.id,
            qualificationName: obj.qualificationName,
            qualificationDescription: obj.qualificationDescription,
            dateCreated: obj.dateCreated,
            dateModified: obj.dateModified,
            cost: obj.cost,
            duration: obj.duration
        });
        setPreviewModal(true)
    }

    function closePreviewModal() {
        setPreviewModal(false);
        setFormErrors({});
    }

    function closeAddModal() {
        setAddModal(false);
        setFormErrors({});
    }

    function openAddModel() {
        setAddModal(true);
        setFormErrors({});
    }

    function openDeleteModal() {
        const frmFormData = new FormData();
        const sURL = "HMCareSettings/deleteskill/" + selectedData.id;
        api.post(sURL, frmFormData)
            .then((Response) => {
                if (Response.data === true) {
                    const updatedDataList = DatatoUse.filter((item) => item.id !== selectedData.id)
                    setData(updatedDataList);
                }
            }).catch(error => {
                setError(error);
            });
        setPreviewModal(false);
        setFormErrors({});
    }

    function validateFields({ name, cost, desc, duration }) {
        const errors = {};
        if (!name.trim()) errors.name = "Name is required";
        if (!desc.trim()) errors.desc = "Description is required";
        if (!cost || isNaN(cost) || Number(cost) < 0) errors.cost = "Cost is required and must be a number (0 or greater)";
        if (!duration.trim()) errors.duration = "Duration is required";
        return errors;
    }

    function handleFormSubmit(event) {
        event.preventDefault();
        const f = modalForm.current;
        const newName = f.querySelector('#dataname').value;
        const newCost = f.querySelector('#datacost').value;
        const newDesc = f.querySelector('#datadesc').value;
        const newDuration = f.querySelector('#dataduration').value;
        const errors = validateFields({ name: newName, cost: newCost, desc: newDesc, duration: newDuration });
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) return;

        const frmFormData = new FormData();
        frmFormData.append("id", selectedData.id);
        frmFormData.append("qualificationName", newName);
        frmFormData.append("qualificationDescription", newDesc);
        frmFormData.append("cost", newCost);
        frmFormData.append("duration", newDuration);

        const sURL = "HMCareSettings/updateskills/";
        api.post(sURL, frmFormData)
            .then((Response) => {
                let updatedDataObj = Response.data;
                updateState(updatedDataObj)
            }).catch(error => {
                setError(error);
            });

        setPreviewModal(false);
    }

    function handleAddFormSubmit(event) {
        event.preventDefault();
        const f = modalForm.current;
        const newName = f.querySelector('#dataname').value;
        const newCost = f.querySelector('#datacost').value;
        const newDesc = f.querySelector('#datadesc').value;
        const newDuration = f.querySelector('#dataduration').value;
        const errors = validateFields({ name: newName, cost: newCost, desc: newDesc, duration: newDuration });
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) return;
        const frmFormData = new FormData();
        frmFormData.append("qualificationName", newName);
        frmFormData.append("qualificationDescription", newDesc);
        frmFormData.append("cost", newCost);
        frmFormData.append("duration", newDuration);

        const sURL = "HMCareSettings/addskill/";
        api.post(sURL, frmFormData)
            .then((Response) => {
                let updatedDataObj = Response.data;
                const UpdateList = [{
                    id: updatedDataObj.id,
                    qualificationName: updatedDataObj.qualificationName,
                    qualificationDescription: updatedDataObj.qualificationDescription,
                    cost: updatedDataObj.cost,
                    duration: updatedDataObj.duration,
                    dateCreated: updatedDataObj.dateCreated,
                    dateModified: updatedDataObj.dateModified,
                }, ...DatatoUse]
                setData(UpdateList)
            }).catch(error => {
                setError(error);
            });

        setAddModal(false);
    }

    const updateState = (updatedData) => {
        const newState = DatatoUse.map(obj => {
            if (obj.id === updatedData.id) {
                return {
                    ...obj,
                    qualificationName: updatedData.qualificationName,
                    qualificationDescription: updatedData.qualificationDescription,
                    cost: updatedData.cost,
                    duration: updatedData.duration
                }
            }
            return obj;
        });
        setData(newState);
    };

    return (
        <>
            <Layout title="HMCarePlanner - Settings" content="container">
                <Block.Head page className="wide-md">
                    <Block.HeadContent>
                        <Block.Title>{pagetitle}</Block.Title>
                        <Block.Text>Manage {pagetitle} settings</Block.Text>           
                    </Block.HeadContent>
                </Block.Head>
                <BlockHead page>
                    <BlockHeadBetween>
                        <BlockHeadContent>
                            {error && 
                                <Alert variant="danger">
                                    {error}
                                </Alert>
                            }        
                        </BlockHeadContent>
                        <BlockHeadContent tools>
                            <Button variant="outline-primary" action="add" onClick={openAddModel}>
                                <Icon name="plus"></Icon><span>{pagetitleAddNew}</span>
                            </Button>
                        </BlockHeadContent>
                    </BlockHeadBetween>
                </BlockHead>

                <DataTable 
                    tableClassName="data-table-head-light table-responsive" 
                    pointerOnHover={true} 
                    data={DatatoUse}                     
                    columns={tableColumns} 
                    striped={true} 
                    highlightOnHover={true}  
                    filterFieldName="qualificationName" 
                    onRowClicked={(row,event)=>{ detailSelect(row) }}            
                />        
            </Layout>


            {/* ---- EDIT MODAL ---- */}
            <Modal show={previewModal} onHide={closePreviewModal}>
                <Modal.Header closeButton>
                    <Modal.Title className="event-title" as="h4">Modify {pagetitle} - {selectedData.qualificationName}(#{selectedData.id})</Modal.Title>  
                </Modal.Header>
                <Form ref={modalForm} onSubmit={handleFormSubmit}>
                <Modal.Body>
                <div>
                    <Row className="g-3">       
                        <Col xs="12">
                            <Form.Group>
                                <h6 className="overline-title">Name</h6>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="dataname"
                                        type="text"
                                        defaultValue={selectedData.qualificationName}
                                        placeholder="Name"
                                        isInvalid={!!formErrors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.name}</Form.Control.Feedback>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col xs="12">
                            <Form.Group>
                                <h6 className="overline-title">Description</h6>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="datadesc"
                                        as="textarea"
                                        rows={3}
                                        defaultValue={selectedData.qualificationDescription}
                                        placeholder="Description"
                                        isInvalid={!!formErrors.desc}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.desc}</Form.Control.Feedback>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col xs="12">
                            <Form.Group>
                                <h6 className="overline-title">Cost</h6>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="datacost"
                                        type="number"
                                        step="0.01"
                                        min={0}
                                        defaultValue={selectedData.cost}
                                        placeholder="Cost"
                                        isInvalid={!!formErrors.cost}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.cost}</Form.Control.Feedback>
                                </div>
                            </Form.Group>
                        </Col>
                       <Col xs="12">
                            <Form.Group>
                                <h6 className="overline-title">Duration</h6>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="dataduration"
                                        type="text"
                                        defaultValue={selectedData.duration}
                                        placeholder="Duration (months)"
                                        isInvalid={!!formErrors.duration}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.duration}</Form.Control.Feedback>
                                </div>
                            </Form.Group>
                        </Col>
                        <Col xs="12">
                            <h6 className="overline-title">Date Created</h6>
                            <p className="event-end small">{selectedData.dateCreated} </p>
                        </Col>
                        <Col xs="12">
                            <h6 className="overline-title">Date Modified</h6>
                            <p className="event-end small">{selectedData.dateModified} </p>
                        </Col>        
                    </Row>
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closePreviewModal}>Cancel</Button>
                    <Button variant="danger" onClick={openDeleteModal}>Delete</Button>
                    <Button variant="primary" type="submit">{pagetitleUpdate}</Button>
                </Modal.Footer>
                </Form>
            </Modal>

            {/* ---- ADD MODAL ---- */}
            <Modal show={AddModal} onHide={closeAddModal}>
                <Modal.Header closeButton>
                    <Modal.Title className="event-title" as="h4">{pagetitleAddNew}</Modal.Title>  
                </Modal.Header>
                <Form ref={modalForm} onSubmit={handleAddFormSubmit}>
                <Modal.Body>
                <div>
                    <Row className="g-3">       
                        <Col xs="12">
                            <Form.Group>
                                <Form.Label>Name</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="dataname"
                                        type="text"
                                        defaultValue={''}
                                        placeholder="Name"
                                        isInvalid={!!formErrors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.name}</Form.Control.Feedback>
                                </div>
                                <Form.Label>Description</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="datadesc"
                                        as="textarea"
                                        rows={3}
                                        defaultValue={''}
                                        placeholder="Description"
                                        isInvalid={!!formErrors.desc}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.desc}</Form.Control.Feedback>
                                </div>
                                <Form.Label>Cost</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="datacost"
                                        type="number"
                                        defaultValue={''}
                                        placeholder="Cost"
                                        min={0}
                                        step="0.01"
                                        isInvalid={!!formErrors.cost}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.cost}</Form.Control.Feedback>
                                </div>
                                <Form.Label>Duration</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control
                                        id="dataduration"
                                        type="text"
                                        defaultValue={''}
                                        placeholder="Duration (months)"
                                        min={1}
                                        isInvalid={!!formErrors.duration}
                                    />
                                    <Form.Control.Feedback type="invalid">{formErrors.duration}</Form.Control.Feedback>
                                </div>
                            </Form.Group>
                        </Col>        
                    </Row>
                </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeAddModal}>Cancel</Button>
                    <Button variant="primary" type="submit">{pagetitleAddNew}</Button>
                </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default SkillsSettings;



// const SkillsSettings = () => {

//     const api = useApiClient();

//     const dataFetchedRef = useRef(false);

//     const [DatatoUse, setData] = useState(null);
//     const [error, setError] = useState(null);
  
//     const modalForm = useRef(null);
//     const modalFormAdd = useRef(null);
//     const [selectedData, setSelectedData] = useState([]);
//     const [previewModal, setPreviewModal] = useState(false);
//     const [AddModal, setAddModal] = useState(false);
    
    

//     useEffect(()=> {

//         if (dataFetchedRef.current) return;
//         dataFetchedRef.current = true;
        
//         api.get(baseURL)        
//         .then((Response)=>{
//             setData(Response.data);
//         }).catch(error => {
//             setError(error);     
//             console.log({error})
//         });

//     },[])

//     if (error) 
//         {      
//           if(error.message.indexOf("status code 401")){
//             return <Navigate to="/auths/auth-login" />
//           } else
//           return "Error: ${error.message}";
//         }
    
//         if(!DatatoUse) return(
//             <Layout title="Data" content="container"><Spinner animation="border" variant="primary" /></Layout>
//         );

// function detailSelect(obj){

//     console.log(obj);

//     const currentData = {...selectedData,
//     id:obj.id,
//     qualificationName:obj.qualificationName,
//     qualificationDescription:obj.qualificationDescription,
//     dateCreated: obj.dateCreated,
//     dateModified: obj.dateModified,
//     cost: obj.cost,
//     duration: obj.duration
//     }

//     setSelectedData(currentData)
//     setPreviewModal(true)

//     }



// function closePreviewModal(){
//     setPreviewModal(false);
//     } 

// function closeAddModal(){
//     setAddModal(false);
//     } 

// function openAddModel(){
//     setAddModal(true);
//     } 
    

// function openDeleteModal(){

//     const frmFormData = new FormData();
//     const sURL = "HMCareSettings/deleteskill/"+selectedData.id;

//     api.post(sURL,frmFormData)
//     .then((Response)=>{

//         if(Response.data==true){      
//         const updatedDataList = DatatoUse.filter((item) => item.id !== selectedData.id)
//         setData(updatedDataList);
//         }                          
//     }).catch(error => {
//         setError(error);     
//         console.log({error})
//     });

//     setPreviewModal(false);

//     }   

// function openEditModal(){
//     //setPreviewModal(false);
//     }   


// const updateState = (updatedData) => {

//     const newState = DatatoUse.map(obj => {
//         // 👇️ if id equals 2, update country property
//         if (obj.id === updatedData.id) {
//         return {...obj, 
//             qualificationName: updatedData.qualificationName,
//             qualificationDescription: updatedData.qualificationDescription,
//             cost:updatedData.cost,            
//             duration:updatedData.duration            
//         };
//         }

//         // 👇️ otherwise return the object as is
//         return obj;
//     });
    
//     setData(newState);
    
//     };


//     function handleFormSubmit(event){

//         event.preventDefault();
//         let newName = modalForm.current.querySelector('#dataname').value;
//         let newCost = modalForm.current.querySelector('#datacost').value;
//         let newDesc = modalForm.current.querySelector('#datadesc').value;
//         let newDuration = modalForm.current.querySelector('#dataduration').value;
//         console.log(newName);
        
//         const frmFormData = new FormData();
//         frmFormData.append("id", selectedData.id) 
//         frmFormData.append("qualificationName", newName) 
//         frmFormData.append("qualificationDescription", newDesc) 
//         frmFormData.append("cost", newCost) 
//         frmFormData.append("duration", newDuration) 
        
//         const sURL = "HMCareSettings/updateskills/";

//         api.post(sURL,frmFormData)
//         .then((Response)=>{

//             let updatedDataObj = Response.data;            
//             updateState(updatedDataObj)
            
//         }).catch(error => {
//             setError(error);     
//             console.log({error})
//         });

//         setPreviewModal(false);

//     }   


//     function handleAddFormSubmit(event){

//         event.preventDefault();
//         let newName = modalForm.current.querySelector('#dataname').value;
//         let newCost = modalForm.current.querySelector('#datacost').value;
//         let newDesc = modalForm.current.querySelector('#datadesc').value;
//         let newDuration = modalForm.current.querySelector('#dataduration').value;

        

//         //console.log(newstatus);
        
//         const frmFormData = new FormData();          
//         frmFormData.append("qualificationName", newName) 
//         frmFormData.append("qualificationDescription", newDesc) 
//         frmFormData.append("cost", newCost) 
//         frmFormData.append("duration", newDuration) 
        
        
//         const sURL = "HMCareSettings/addskill/";
       
//         api.post(sURL,frmFormData)
//         .then((Response)=>{

//             let updatedDataObj = Response.data;            

//             const UpdateList = [{
//                 id : updatedDataObj.id,
//                 qualificationName : updatedDataObj.qualificationName,
//                 qualificationDescription : updatedDataObj.qualificationDescription,
//                 cost : updatedDataObj.cost,
//                 duration : updatedDataObj.duration,
//                 dateCreated : updatedDataObj.dateCreated,
//                 dateModified : updatedDataObj.dateModified,
//             },...DatatoUse]    

//             //console.log(UpdateList)

//             setData(UpdateList)    

            
//         }).catch(error => {
//             setError(error);     
//             console.log({error})
//         });

//         setAddModal(false);

//     }   



//   return (

//     <>
//     <Layout title="HMCarePlanner - Settings" content="container">
//     <Block.Head page className="wide-md">
//         <Block.HeadContent>
//             <Block.Title>{pagetitle}</Block.Title>
//             <Block.Text>Manage {pagetitle} settings</Block.Text>           
//         </Block.HeadContent>
//     </Block.Head>    
//     <BlockHead page>    
//     <BlockHeadBetween>
//        <BlockHeadContent>
//                     {error && 
//                     <Alert variant="danger">
//                         {error}
//                     </Alert>
//                     }        
//        </BlockHeadContent>
//        <BlockHeadContent tools>      
//          <Button variant="outline-primary" action="add" onClick={openAddModel}>
//              <Icon name="plus"></Icon><span>{pagetitleAddNew}</span>
//          </Button>
//        </BlockHeadContent>
//     </BlockHeadBetween>
//     </BlockHead>

//         <DataTable 
//             tableClassName="data-table-head-light table-responsive" 
//             pointerOnHover={true} 
//             data={DatatoUse}                     
//             columns={tableColumns} 
//             striped={true} 
//             highlightOnHover={true}  
//             filterFieldName="qualificationName" 
//             onRowClicked={(row,event)=>{ detailSelect(row) }}            
//             //actions="export"             
//         />        
//     </Layout>

// <Modal show={previewModal} onHide={closePreviewModal}>
// <Modal.Header closeButton>
//   <Modal.Title className="event-title" as="h4">Modify {pagetitle} - {selectedData.qualificationName}(#{selectedData.id})</Modal.Title>  
// </Modal.Header>

// <Form ref={modalForm} onSubmit={handleFormSubmit}>
// <Modal.Body>
//   <div>
//     <Row className="g-3">       
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">Name</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="dataname" type="text" defaultValue={selectedData.qualificationName} placeholder="Value" />
//                 </div>
//             </Form.Group>
//         </Col>
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">Description</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="datadesc" type="textarea" defaultValue={selectedData.qualificationDescription} placeholder="Value" />
//                 </div>
//             </Form.Group>
//         </Col>
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">Cost</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="datacost" type="text" defaultValue={selectedData.cost} placeholder="Value" />
//                 </div>
//             </Form.Group>
//         </Col>
//         <Col xs="12">
//             <Form.Group>
//                 <h6 className="overline-title">Duration</h6>
//                 <div className="form-control-wrap">
//                     <Form.Control id="dataduration" type="text" defaultValue={selectedData.duration} placeholder="Value" />
//                 </div>
//             </Form.Group>
//         </Col>
//         <Col xs="12">
//             <h6 className="overline-title">Date Created</h6>
//             <p className="event-end small">{selectedData.dateCreated} </p>
//         </Col>
//         <Col xs="12">
//             <h6 className="overline-title">Date Modified</h6>
//             <p className="event-end small">{selectedData.dateModified} </p>
//         </Col>        
//     </Row>
//   </div>
// </Modal.Body>
// <Modal.Footer>
//     <Button variant="danger" onClick={openDeleteModal}>Delete</Button>    
//     <Button variant="primary" type="submit">{pagetitleUpdate}</Button>
// </Modal.Footer>
// </Form>
// </Modal>

// <Modal show={AddModal} onHide={closeAddModal}>
// <Modal.Header closeButton>
//   <Modal.Title className="event-title" as="h4">{pagetitleAddNew}</Modal.Title>  
// </Modal.Header>

// <Form ref={modalForm} onSubmit={handleAddFormSubmit}>
// <Modal.Body>
//   <div>
//     <Row className="g-3">       
//         <Col xs="12">
//             <Form.Group>
//                 <Form.Label htmlFor="eventTitle">Name</Form.Label>
//                 <div className="form-control-wrap">
//                     <Form.Control id="dataname" type="text" defaultValue={''} placeholder="Value" />
//                 </div>
//                 <Form.Label htmlFor="Desc">Description</Form.Label>
//                 <div className="form-control-wrap">
//                     <Form.Control id="datadesc" type="textarea" defaultValue={''} placeholder="Description" />
//                 </div>
//                 <Col xs="12">
//                     <Form.Group>
//                         <h6 className="overline-title">Cost</h6>
//                         <div className="form-control-wrap">
//                             <Form.Control id="datacost" type="text" defaultValue={''} placeholder="Value" />
//                         </div>
//                     </Form.Group>
//                 </Col>
//                 <Col xs="12">
//                     <Form.Group>
//                         <h6 className="overline-title">Duration</h6>
//                         <div className="form-control-wrap">
//                             <Form.Control id="dataduration" type="text" defaultValue={''} placeholder="Value" />
//                         </div>
//                     </Form.Group>
//                 </Col>
//             </Form.Group>
            
//         </Col>        
//     </Row>
//   </div>
// </Modal.Body>
// <Modal.Footer>
//     <Button variant="primary" type="submit">{pagetitleAddNew}</Button>
// </Modal.Footer>
// </Form>
// </Modal>

// </>
//   )
// }

// export default SkillsSettings